import { render, staticRenderFns } from "./ad-product-types-count.vue?vue&type=template&id=9edd19a0"
import script from "./ad-product-types-count.vue?vue&type=script&lang=ts"
export * from "./ad-product-types-count.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports